import { CustomNodeType, actionBarHeight } from './config';

export interface ActionBtns {
  switchAction: boolean | Record<string, any>;
  linkAction: boolean | Record<string, any>;
  addAction: boolean | Record<string, any>;
  settingAction: boolean | Record<string, any>;
  deleteAction: boolean | Record<string, any>;
}

function clickHandler(e) {
  const target = e.target as HTMLElement;
  // 开关
  if (target.classList.contains('activity-actionbar-switch-btn')) {
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onActivityToggleSwitch(id);
  }
  // 链接
  else if (target.classList.contains('activity-actionbar-link-btn')) {
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onActivityLinkProducts(id);
  }
  // 添加
  else if (target.classList.contains('activity-actionbar-add-btn')) {
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onActivityAdd(id);
  }
  // 设置
  else if (target.classList.contains('activity-actionbar-setting-btn')) {
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onActivitySettings(id);
  }
  // 删除
  else if (target.classList.contains('activity-actionbar-del-btn')) {
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onActivityDelete(id);
  }
}

export const generateActionBar = function (node: any) {
  node.actionBar =
    node.actionBar ||
    ({
      switchAction: { open: true },
      linkAction: true,
      addAction: true,
      settingAction: true,
      deleteAction: true
    } as ActionBtns);

  let hasSettings = false;

  if (node.level === 2) {
    if (node.type === CustomNodeType.POLICY && node?.policyInfo.name) {
      hasSettings = true;
    }
  } else if (node.level === 3) {
    const rightsInfoHasSetting =
      [CustomNodeType.RIGHTS_INFO, CustomNodeType.SIMPLE_RIGHTS_INFO].includes(node.type) &&
      node?.equityInformationRule?.name;
    if (rightsInfoHasSetting) {
      hasSettings = true;
    }
  }
  const conditionHasSetting =
    [CustomNodeType.CONDITIONS, CustomNodeType.SIMPLE_CONDITION].includes(node.type) &&
    (node.isPre ? node?.conditionDesc : node?.effectConditionDesc);
  if (conditionHasSetting) {
    hasSettings = true;
  }

  const switchBtn = `
    <span style="font-size:12px;color:#333;width:30px;line-height: 1.2;">前置条件</span>
    <span data-id="${node.id}" class="activity-actionbar-switch-btn iconfont icon-kaiguan-${
    node?.hasPrecondition ? 'kai' : 'guan'
  }" style="font-size:28px;color:#333;cursor:pointer;" ></span>
  `;
  const linkBtn = `<span data-id="${
    node.id
  }" class="activity-actionbar-link-btn iconfont icon-lianjie" style="margin-left:5px;font-size:18px;color:${
    node.promotionItemStr || node?.equityInformationRule?.equityInfoItemStr ? '#d70a25' : '#333'
  };cursor:pointer;"></span>`;
  const addBtn = `<span data-id="${node.id}" class="activity-actionbar-add-btn iconfont icon-tianjia" style="margin-left:5px;font-size:18px;color:#333;cursor:pointer;"></span>`;
  const settingBtn = `<span data-id="${
    node.id
  }" class="activity-actionbar-setting-btn iconfont icon-shezhi" style="margin-left:5px;font-size:18px;color:${
    hasSettings ? '#d70a25' : '#333'
  };cursor:pointer;"></span>`;
  const deleleBtn = `<span data-id="${node.id}" class="activity-actionbar-del-btn iconfont icon-shanchu" style="margin-left:5px;font-size:18px;color:#333;cursor:pointer;"></span>`;

  // 只监听一次事件
  document.body.removeEventListener('click', clickHandler);
  document.body.addEventListener('click', clickHandler);

  return `
    <div style="display: flex;align-items: center;height: ${actionBarHeight}px;">
      <div style="display: flex;align-items: center;">
        ${node.actionBar.switchAction?.show&&node.optionType !== "DIRECT_DESCENT" ? switchBtn : ''}
      </div>
      <div style="margin-left:auto;display: flex;align-items: center;">
        ${node.actionBar.linkAction ? linkBtn : ''}
        ${node.actionBar.addAction ? addBtn : ''}
        ${node.actionBar.settingAction ? settingBtn : ''}
        ${node.actionBar.deleteAction ? deleleBtn : ''}
      </div>
    </div>
  `;
};
